import { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Home", href: "/" },
  { label: "Find Nursing Homes", href: "/#matcher" },
  { label: "Care Services", href: "/#care-services" },
  { label: "Caregiver Packages", href: "/caregiver-packages/" },
  { label: "Nursing Home Costs", href: "/pricing-guide/" },
  { label: "Guides", href: "/how-to-choose-a-nursing-home/" },
  { label: "About Us", href: "/#about" },
  { label: "Contact", href: "/contact/" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="site-header" className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="/" data-testid="header-logo-link" aria-label="Nursing Home in Penang — home" className="flex items-center shrink-0">
            <img src="/assets/logo-mark.png" alt="Nursing Home in Penang logo" width="360" height="180" className="h-10 md:h-12 w-auto" />
          </a>
          <nav className="hidden lg:flex items-center gap-6" aria-label="Main navigation">
            {NAV.slice(1).map((item) => (
              <a key={item.label} href={item.href} data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm font-medium text-brand-charcoal/80 hover:text-brand-teal transition-colors duration-200">
                {item.label}
              </a>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <a
              href="/#matcher"
              data-testid="header-find-home-btn"
              className="hidden sm:inline-flex items-center rounded-full bg-brand-gold px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-brand-teal hover:-translate-y-0.5 transition-all duration-300"
            >
              Find a Nursing Home
            </a>
            <button
              type="button"
              data-testid="mobile-menu-button"
              onClick={() => setOpen(!open)}
              aria-expanded={open}
              aria-label={open ? "Close menu" : "Open menu"}
              className="lg:hidden rounded-lg p-2 text-brand-teal hover:bg-brand-tealLight transition-colors"
            >
              {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="lg:hidden border-t border-slate-100 bg-white px-4 py-4 space-y-1" aria-label="Mobile navigation">
          {NAV.map((item) => (
            <a
              key={item.label}
              href={item.href}
              data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setOpen(false)}
              className="block rounded-lg px-4 py-3 text-base font-medium text-brand-charcoal hover:bg-brand-tealLight hover:text-brand-teal transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Header;
